<!--
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 *
 *
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *            佛祖保佑       永不宕机     永无BUG
 *
 * @Author: DY
 * @Date: 2021-11-16 11:26:07
 * @LastEditTime: 2026-06-26 12:08:17
 * @Description: 当前流程所有附件
 * @Param:
 * @FilePath: \ConcreteCloud_Mobile\src\views\salesTerminal\contractApproval\allProcedureAnnex.vue
 -->

<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="allProcedureAnnex">
            <van-nav-bar
                left-arrow
                title="合同汇总资料"
                left-text="审批办理"
                v-if="type != 'process_message'"
                @click-left="swiperright"
            >
            </van-nav-bar>
            <section>
                <div class="btns">
                    <template v-for="(item, index) in annexData">
                        <button :key="`navBtn_${index}`" :class="{'active': nanvIndex == index}" @click="switchAttachments(index)">
                            {{ item.name }}
                        </button>
                    </template>
                </div>
                <div class="appendix_list" :class="{'noData': attachmentData.length == 0}">
                    <button v-if="thisFileID != '0'" class="attachmentReturnBtn iconfont iconfanhui2" @click="attachmentReturn">
                        返回上一级
                    </button>
                    <ul>
                        <template v-for="(item, index) in attachmentData">
                            <li
                                :key="`attachment_${index}`"
                                @click="attachmentPreview(item)"
                                :class="{'folder':item.FileType == '1', 'file': item.FileType == '2'}"
                            >
                                <span class="iconfont fileIcon" :class="addClassName(item)"></span>
                                <div class="fileInfo">
                                    <p class="fileName">
                                        {{ item.FileName }}
                                    </p>
                                    <p v-if="item.FileType !== '1'">
                                        <em>{{ item.CreateDate || '暂无日期' }}</em>
                                        <em v-if="item.FileType !== '1'">
                                            <template v-if="item.FileSize > 1048576">
                                                {{ (item.FileSize/1048576).toFixed(2) }}M
                                            </template>
                                            <template v-else-if="item.FileSize < 1048576 && item.FileSize > 1024">
                                                {{ (item.FileSize/1024).toFixed(2) }}k
                                            </template>
                                            <template v-else>
                                                {{ item.FileSize }}b
                                            </template>
                                        </em>
                                    </p>
                                </div>
                                <i class="iconfont iconfanhui1"></i>
                            </li>
                        </template>
                    </ul>
                </div>
            </section>
        </div>
    </v-touch>
</template>
<script>
import { ImagePreview } from 'vant';

export default {
    name: 'all-procedure-annex',
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path !== '/attachmentPreview') {
            this.$store.commit('noKeepAlive', 'all-procedure-annex');
        }
        next();
    },
    props: {},
    data() {
        return {
            annexData: [{
                name: '合同信息',
                idsName: 'contractBusinessInstanceIds',
            }, {
                name: '合同变更',
                idsName: 'modificationBusinessInstanceIds',
            }, {
                name: '合同调价',
                idsName: 'adjustmentPriceBusinessInstanceIds',
            }, {
                name: '超限申请',
                idsName: 'transfiniteBusinessInstanceIds',
            }],
            nanvIndex: 0,
            allAnnexSortData: {},
            // 显示附件数据
            attachmentData: [],
            // 所有附件数据
            allAttachmentData: [],
            thisFileID: '0',
            type: '',
            newsToken: '',
            businessInstanceInfo: '',

        };
    },
    computed: {},
    watch: {},
    created() {
        this.type = this.$route.params.type;
        this.newsToken = this.$route.params.thisToken;
        this.businessInstanceInfo = this.$route.params.businessInstanceInfo;

        this.init();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },

        // 附件类型切换
        switchAttachments(index) {
            this.nanvIndex = index;
            this.allAttachmentData = [];
            this.attachmentData = [];
            this.processingAttachmentData(this.annexData[index]);
        },

        async init() {
            // eslint-disable-next-line max-len
            this.allAnnexSortData = await this.getAllAnnexSortData(this.businessInstanceInfo.BusinessInstanceId, this.businessInstanceInfo.standard_code);
            this.processingAttachmentData(this.annexData[0]);
        },

        // 处理附件数据
        async processingAttachmentData(data) {
            if ((this.allAnnexSortData[data.idsName] || []).length > 0) {// 合同信息附件
                this.allAttachmentData = await this.getAllAnnexData(this.allAnnexSortData[data.idsName]);
            }
            if (Object.keys(this.allAttachmentData).length > 0) {
                this.attachmentData = this.allAttachmentData.filter(item => item.ParentID === '0');
            }
        },

        // 附件预览
        attachmentPreview(data) {
            if (data.FileType !== '1') {
                this.$router.isBack = 2;
                const fileFormat = data.FileName.substring(data.FileName.length - 4, data.FileName.length);
                if (
                    fileFormat.indexOf('jpg') > -1
                    || fileFormat.indexOf('png') > -1
                    || fileFormat.indexOf('gif') > -1
                    || fileFormat.indexOf('jpeg') > -1
                ) {
                    this.getFileDetailFun(data.AFI_Code, 'preview_url');
                    setTimeout(() => {
                        ImagePreview({
                            images: [this.url],
                            closeable: true,
                        });
                    }, 300);
                } else {
                    this.getFileDetailFun(data.AFI_Code, 'preview_url');
                    setTimeout(() => {
                        this.$router.push({
                            name: 'attachmentPreview',
                            params: {
                                url: this.url,
                                isNews: this.isNews,
                            },
                        });
                    }, 300);
                }
            } else {
                this.thisFileID = data.FileID;
                this.attachmentData = this.allAttachmentData.filter(item => item.ParentID === data.FileID);
            }
        },
        // 获取文件下载预览地址
        getFileDetailFun(id, key) {
            this.url = `${this.GLOBAL.FILE_BASE_URL}file-manage/${id}/download`;
        },

        // 附件返回上一级
        attachmentReturn() {
            const new_ParentID = this.allAttachmentData.filter(item => item.FileID === this.thisFileID)[0].ParentID;
            this.attachmentData = this.allAttachmentData.filter(item => item.ParentID === new_ParentID);
            this.thisFileID = this.attachmentData[0].ParentID;
        },

        // 附件图标
        addClassName(item) {
            let className = '';
            if (item.FileType === '1') {
                className = 'iconfujian';
            } else if (item.FileType === '2') {
                if (/png/i.test(item.FileName)) {
                    className = 'icontupian';
                } else if (/jpg/i.test(item.FileName)) {
                    className = 'icontupian';
                } else if (/gif/i.test(item.FileName)) {
                    className = 'icontupian';
                } else if (/pdf/i.test(item.FileName)) {
                    className = 'iconpdf1';
                } else if (/docx/i.test(item.FileName)) {
                    className = 'iconbg-word';
                } else if (/xlsx/i.test(item.FileName)) {
                    className = 'iconxls';
                } else if (/ppt/i.test(item.FileName)) {
                    className = 'iconPPT';
                } else if (/txt/i.test(item.FileName)) {
                    className = 'icontxt';
                } else {
                    className = 'iconPPT';
                }
            }
            return className;
        },


        // 获取所有附件分类数据
        getAllAnnexSortData(businessInstanceId, standard_code) {
            const path = `/interfaceApi/sale/contract_manager/contract_collect_file/${businessInstanceId}/${standard_code}`;
            return this.$axios.$get(path, { defEx: true, token: this.newsToken });
        },
        // 获取分类下附件数据
        getAllAnnexData(filegroupinfoIds) {
            const path = '/interfaceApi/basicplatform/simpleflow/filegroupinstance/filegroupinfo_byids';
            return this.$axios.$post(path, [...filegroupinfoIds], { defEx: true, token: this.newsToken });
        },
    },
};
</script>
<style lang="stylus" scoped>
.allProcedureAnnex
    height: 100%
    section
        height calc(100% - 44rpx)
        .btns
            height 60rpx
            display: flex
            justify-content: space-around
            align-items center
            border-bottom 1px solid #F0F0F0
            button
                width 75rpx
                height 30rpx
                border none
                border-radius: 4rpx
                font-size 14rpx
                color #666666
                background: #F0F0F0
                &.active
                    background: #0091FF
                    color #fff
        .appendix_list
            height calc(100% - 60rpx)
            overflow: scroll;
            -webkit-overflow-scrolling: touch;
            .attachmentReturnBtn
                width 120rpx
                height: 30rpx
                border 1px solid #91D5FF
                background: #E6F7FF
                font-size 12rpx
                color #1890FF
                border-radius: 0px 10rpx 0px 0px;
            &.noData
                background: url(../../../assets/images/common/no_data.png) center no-repeat
                background-size: 100%
            ul
                li
                    display flex
                    align-items center
                    width 100%
                    padding 12rpx
                    border-bottom 1px solid #ebedf0
                    >i
                        line-height: 50rpx
                        width 30rpx
                        text-align: right
                        display: none
                    &.folder
                        i
                            display: block
                    &.file
                        .fileInfo
                            width calc(100% - 50rpx)
            .fileName
                width 100%
                white-space nowrap
                text-overflow ellipsis
                overflow hidden
            .fileIcon
                font-size 16rpx
                width 50rpx
                text-align center
                height 50rpx
                line-height 50rpx
                &:first-child
                    font-size 26rpx
                &:last-child
                    font-size 14rpx
                    color #979EA7
                &.icontupian::before
                    color rgba(133, 115, 226, 1)
                &.iconpdf1::before
                    color rgba(255, 85, 98, 1)
                &.iconbg-word::before
                    color rgba(84, 141, 254, 1)
                &.iconxls::before
                    color rgba(72, 203, 129, 1)
                &.iconPPT::before
                    color rgba(255, 147, 51, 1)
                &.icontxt::before
                    color #f60
            .fileInfo
                width calc(100% - 80rpx)
                p
                    font-size 16rpx
                    color #000
                    line-height 24rpx
                    &:last-child
                        display flex
                        justify-content space-between
                        em
                            font-size 14rpx
                            color #979EA7
            .iconfujian
                color #3495FB
</style>
